
<template>
    <div class="app-content margen-content">
        <div class="row">
            <div class="col-sm-12">
                  <div class="vx-row">
                    <carousel-principal></carousel-principal>
                  </div>
                  <div class="vx-row p-4  w-full" style="padding-bottom:0px !important;">
                    <b>PRODUCTOS DESTACADOS</b>
                  </div>
                <vs-divider position="center"></vs-divider>
                  <div class="vx-row">
                    <carousel-items-ofert-horizontal></carousel-items-ofert-horizontal>
                  </div>
            </div>
          </div>
    </div>
</template>

<script>
import 'swiper/dist/css/swiper.min.css'
import CarouselItemsOfertHorizontal from './components-list-carousel/CarouselItemsOfertHorizontal.vue'
import CarouselItemsOfertVertical from './components-list-carousel/CarouselItemsOfertVertical.vue'
import CarouselPrincipal from './components-list-carousel/CarouselPrincipal.vue'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {

    data() {
        return {

        }
    },
    components: {
        swiper,
        swiperSlide,
        CarouselItemsOfertHorizontal,
        CarouselItemsOfertVertical,
        CarouselPrincipal
    },
    created(){
      console.log(process.env.VUE_APP_DOMAIN_WS)
    }

}
</script>
<style>

</style>